var data = {
	"body": "<path d=\"M11.5 4a8.5 8.5 0 1 0 .001 17.001A8.5 8.5 0 0 0 11.5 4zm0-1a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3zM11 17h1v2h-1v-2zm.5-11A3.5 3.5 0 0 1 15 9.5c0 .897-.699 1.519-1.439 2.176l-.935.903c-.588.674-.652 1.955-.627 2.392V15H11c-.004-.052-.102-1.964.874-3.079l1.022-.992C13.488 10.403 14 9.948 14 9.5a2.5 2.5 0 1 0-5 0H8A3.5 3.5 0 0 1 11.5 6z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
